import React from "react";
import logoblanco from "../../assets/logoleo.png";
import { Link } from "react-router-dom";
import "./Unetenos.css"

import afiliados12 from "../../assets/contenido/afiliados12.jpg";
import afiliados32 from "../../assets/contenido/afiliados32.jpg";
import afiliados3 from "../../assets/contenido/afiliados3.jpg";


export default function Unetenos() {
    return (
        <div className="contenedor_joinus">
        <nav className="navbar navbar-light mb-5" id="encabezado">
                    <Link to="/" className="container-fluid">
                        <img
                        src={logoblanco}
                        width="290"
                        height="550"
                        className="img-fluid d-block mx-auto"
                        alt='logoMingga'
                        />
                    </Link>
                </nav>
                <div className="container-fluid" align="left" id="padding">

                <h3 id="titulo" align="center"> <b>RECOMIENDANOS:<br />

            <h5>Ayúdanos a crecer, y recibe ingresos de por vida</h5>

            </b> 
            </h3>

            <br />
            <div className="container_bannerus"  align="center">
                <img
                id="imagenajustada"
                className="d-block w-100"
                src={afiliados12}
                width="400"
                height="450"
                alt="..."
                />
                
                </div>
                <br />
                <p>
                Para cumplir con la misión de promover la lectura y escritura en nuestro país y el mundo, <b>LEO</b> necesita crecer, consolidando una gran comunidad educativa basada en la unión y la colaboración entre todos. 
                
                <br />
                    

                <b>El Programa Recomiéndanos,</b> es una invitación de <b>LEO</b> a sus socios para que apoyen este crecimiento, realizando un trabajo muy sencillo, fácil y rápido:
                
                <br /> 
                    
                    <b>Invitar a los familiares, amigos y compañeros de estudio y trabajo a vincularse como Socios LEO, con un máximo de 20 invitados. 
                    Una vez se complete este número, no se podrá invitar a nadie más.</b> 
                
                <br />
                    

                Por este sencillo trabajo que todos podemos realizar, recibiremos ingresos permanentes (de por vida), que estarán disponibles en forma inmediata en nuestra <b>Cuenta Personal</b> 
                
                <br />
                    

                    <b>Recomiéndanos es una alianza estratégica para crecer y progresar juntos:
                <br />
                    
                    <b>LEO</b> crece en el país y el mundo, y los socios construyen un ingreso creciente y permanente que les brindará la independencia económica y una mejor calidad de vida con toda la familia</b>
                </p>

           
            
            <br />
            <h3 id="titulo" align="center"> <b>Recomiéndanos: Principios básicos 
            </b> 
            </h3>
            <br />
            <p>
            • La participación es libre y voluntaria. Un socio puede no participar, y seguir disfrutando de la Biblioteca Digital y los demás programas de promoción de la lectura, escritura y multilingüismo que ofrece  ClubLeo. <br />
            • Se puede invitar a cualquier persona. No existen requisitos ni condiciones previas. Los menores de edad deberán contar con la autorización y tutoría de sus padres, <br />
            • Se puede invitar a personas en nuestro país y cualquier otra nación del mundo. <br />
            • El retiro es libre, en cualquier momento, sin ningún requisito<br />
            • Cada persona puede vincularse una sola vez. Las cuentas múltiples serán anuladas.
            </p>

            <br />
            <h3 id="titulo" align="center"> <b> Cómo funciona Recomiéndanos <br />
            El principio es sencillo: invitar por una sola vez, y obtener ingresos crecientes, de por vida
            </b> 
            </h3>
            <p>
            1. Al vincularnos como socios, creamos nuestro usuario y contraseña; el programa automáticamente genera nuestro link personal, y nos crea “Mi Cuenta” para que hagamos seguimiento en tiempo real a nuestros invitados e ingresos. <br />

            2. Invitamos a nuestros conocidos a que ingresen como socios de <b>LEO</b>, proporcionándoles nuestro usuario o enviándoles a sus redes sociales el link personal que el sistema nos genera. <br />

            3. Al ingresar como socios las personas que invitamos, registran nuestro usuario; y el sistema los va acumulando en nuestra cuenta, hasta completar los 20 solicitados. Después, la lista se cierra y no podremos seguir invitando a más personas. <br />

            4. Según <b>el principio de los 6 grados de integración</b> que aplica <b>LEO</b>, los invitados seguirán creciendo en el país y el mundo, y por cada uno de ellos <b>LEO nos reconocerá un ingreso, que podrá llegar a los COP$10 millones mensuales. <br /> </b> 

            Y lo más importante, la membrecía a <b>CLUBLEO</b> se renueva semestralmente, por lo que este ingreso será permanente, de por vida.<br /> 
                
                Solo debemos invitar una vez a 20 socios, pero <b>LEO</b> nos reconoce ingresos de por vida, con la vinculación y las posteriores renovaciones.


            </p>
            


            <br />
            <h3 id="titulo" align="center"> <b>El Reto para los socios LEO: <br />
            Invitar a nuestros 20 socios en 1 mes
            <br />
            </b> 
            </h3>
            <br />
            <p>
            Si todos los socios logramos vincular a nuestros 20 invitados dentro del mes siguiente al ingreso a <b>LEO</b>, en solo 3 meses empezaremos a recibir un ingreso entre COP$10 y COP$20 millones mensuales, que será permanente gracias a la renovación semestral de la membrecía a CLUBLEO. 
            <b>Es un trabajo sencillo que todos podemos realizar</b>, aprovechando nuestros conocidos (familiares, amigos, vecinos, compañeros de estudio y trabajo), y los contactos en las redes sociales.
            </p>

            <h3 id="titulo" align="center"> <b>Mercado Objetivo LEO. <br />
            Socios potenciales
            <br />
            </b> 
            </h3>


            <div className="container_bannerus1"  align="center">
                <img
                id="imagenajustada"
                className="d-block w-100"
                src={afiliados32}
                width="400"
                height="450"
                alt="..."
                />
                
                </div>
                  <br />
            <br />
            <p>
            <b>CLUBLEO</b> ofrece en su <b>Biblioteca Digital</b> más de 15.000 obras en 5 idiomas, utilizados en más de 100 países del mundo (Anexo), con una población de 1.900 millones de personas, con 1.675 millones mayores de 8 años con capacidad lectora y 476 millones de estudiantes.            </p>
        
            
            <table className="table_1" align="center"> 
                <tr className="table_2" align="center" >
                    <th className="table_3" align="center">Idioma</th>
                    <th className="table_3" align="center">No. de obras</th>
                    <th className="table_3" align="center">Hablantes nativos</th>
                    <th className="table_3" align="center">Mayores de 8 años cap. Lectora</th>
                    <th className="table_3" align="center">Estudiantes</th>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">Español</td>
                    <td className="table_4" align="center">8.169</td>
                    <td className="table_4" align="center">580</td>
                    <td className="table_4" align="center">510</td>
                    <td className="table_4" align="center">145</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">Inglés</td>
                    <td className="table_4" align="center">5.013</td>
                    <td className="table_4" align="center">678</td>
                    <td className="table_4" align="center">597</td>
                    <td className="table_4" align="center">170</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">Francés</td>
                    <td className="table_4" align="center">711</td>
                    <td className="table_4" align="center">300</td>
                    <td className="table_4" align="center">264</td>
                    <td className="table_4" align="center">75</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">Italiano</td>
                    <td className="table_4" align="center">607</td>
                    <td className="table_4" align="center">85</td>
                    <td className="table_4" align="center">75</td>
                    <td className="table_4" align="center">21</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">Portugués</td>
                    <td className="table_4" align="center">614</td>
                    <td className="table_4" align="center">260</td>
                    <td className="table_4" align="center">229</td>
                    <td className="table_4" align="center">65</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center"> <b>Totales </b></td>
                    <td className="table_4" align="center"><b>15.114</b></td>
                    <td className="table_4" align="center"> <b>1.903</b></td>
                    <td className="table_4" align="center"> <b>1.675</b></td>
                    <td className="table_4" align="center"> <b>476</b> </td>
                </tr>


                </table>



                <br />
                <p>
                Aunque todas las personas pueden asociarse, la prioridad de <b>LEO</b> son los 476 millones de estudiantes y sus familias en los diferentes países, para quienes la lectura y escritura son actividades permanentes asociadas al proceso de formación académica, y el fortalecimiento de sus competencias comunicativas es clave para el éxito del proceso educativo. 
                    Con la membrecía semestral de sólo COP$50.000, cada socio accede a la biblioteca digital descargable con 15.000 obras en 5 idiomas, valorada en más de COP$150 millones. Es decir, <b>la membrecía permite acceder a obras con un costo promedio de COP$3 cada una. El costo por libro más económico del mundo!!</b>  
                     Por una monedita de COP$100, recibirás 30 de los mejores libros de literatura y ciencias sociales del mundo!!
                </p>
            <br />
            <h2 id="titulo" align="center"> <b>Recomiéndanos <br />
            Una valiosa oportunidad para asegurar muestra autosostenibilidad financiera, de por vida

            <br />
            </b> 
            </h2>
            <br />
            
           <br />
            <div   align="center">
                <img 
                id="imagenajustada"
                className="d-block w-100"
                src={afiliados3}
                height="250"
                alt="..."
                />
                </div>
                <br />
            
                <h4 id="titulo" align="center"> <b>CLUBLEO <br />
            Somos una comunidad mundial de ganadores</b>

            </h4>
            <br />
            
           <br />
        </div>
    </div>
    );
}
